import classNames from 'classnames';
import React from 'react';

export const Loading: React.FC<{ size?: 'xs' | 'sm' | 'xl' }> = ({ size = 'xl' }) => (
  <>
    <div className={classNames('hide-on-sgbs-4 blinker m-2', {
      'blinker-xl': size === 'xl',
    })} role="status" />
    <div className={classNames('hide-on-sgbs-5 spinner-grow p-2', {
      'spinner-grow-xs': size === 'xs',
      'spinner-grow-sm': size === 'sm',
    })} role="status">
      Loading...
    </div>
  </>
);
